<template>
  <div class="container document-font">
    <div class="card">
      <div class="d-flex card-body flex-column flex-fill">
        <div class="d-flex flex-fill">
          <div class="flex-fill text-left">
            <account-selector v-on:selectedAccount="setOrganization"></account-selector>
          </div>
        </div>
        <div class="text-center mt-3" style="font-weight: 700; font-size: 1.5em;" v-if="organization !== null">
          {{ organization.name }}
          <hr/>
        </div>
        <div v-for="activity in activities" :key="activity.id">
          <div class="d-flex">
            <div style="font-weight: 700">{{ activity.subject }}</div>
            <div class="ml-auto">{{ activity.start_date_string }}</div>
          </div>
          <div>
            <b>MAA Lead:</b> <span style="font-weight: 300">{{ activity.user_name }}</span>
          </div>
          <div>
            <b>Accounts:</b> <span style="font-weight: 300">{{ getAccounts(activity) }}</span>
          </div>
          <div>
            <b>Summary:</b> <span style="font-weight: 300">{{ activity.note }}</span>
          </div>
          <hr/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountSelector from '../tools/AccountSelector'
import activityAPI from '../../api/activity'
export default {
  name: 'activity-index',
  components: {AccountSelector},

  data: function () {
    return {
      organization: null,
      selectedYearAndWeek: null,
      yearAndWeekOptions: [],
      activities: [],
      selectedActivity: null,
      activityDates: [],
      activityTypes: [],
      selectedActivityTypes: []
    }
  },
  methods: {
    setOrganization (e) {
      this.organization = e
      this.setActivities()
    },
    setActivities () {
      activityAPI.getActivityIndex(
        {
          organization_id: this.organization.account_id,
          limit:10000
        }
      ).then(
        response => {
          this.activities = response.data.data.search_results
        }
      )
    },
    getAccounts (activity) {
      let accountString = ''
      for (let i = 0; i < activity.account_objects.length; i++) {
        accountString += activity.account_objects[i].name + ', '
      }
      return accountString.substring(0, accountString.length - 2)
    }
  },
  mounted: function () {
    activityAPI.getPrintableActivityIndex().then(
      result => {
        this.yearAndWeekOptions = result.data.data.dates_of_activities
      }
    )
  }
}
</script>

<style scoped>
  .document-font {
    font-family: Arial, Helvetica,  sans-serif
  }
</style>




// WEBPACK FOOTER //
// src/components/activities/PrintableOrganizationActivityList.vue